module.exports = __webpack_public_path__ + "img/img-3.bfbdb8c6.png";